import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000/api';

const logToServer = (level, message) => {
    // Log para verificar o URL
    axios.post(`${backendUrl}/log`, { level, message })
        .then(response => {
            console.log('Log enviado com sucesso:', response.data);
        })
        .catch(error => {
            console.error('Erro ao enviar log:', error.message);
        });
};

const logger = {
    info: (message) => {
        console.log(`INFO: ${message}`);
        logToServer('info', message);
    },
    warn: (message) => {
        console.warn(`WARN: ${message}`);
        logToServer('warn', message);
    },
    error: (message) => {
        console.error(`ERROR: ${message}`);
        logToServer('error', message);
    },
};

export default logger;
